import { LitElement, html } from 'lit';
import { styles } from '../view/styles';

export class DynamicColumnLayoutWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html` <slot></slot>`;
  }
}
